@if (!layoutService.isTabletDownView.value) {
  <div class="space-tab">
    <ul class="spen-mod-tab-lv-1">
      @for (tab of tabKeys; track tab) {
        @if (isActiveTab(tab)) {
          <li class="is-current" data-cy="tab">
            @if (tabBadge[tab]) {
              <a class="badge-noti" data-cy="tab-badge"></a>
            }
            <p>{{ tabValue(tab) }}</p>
          </li>
        } @else {
          <li (click)="onChangeTab(tab)" class="tab-change-trigger" data-cy="tab">
            @if (tabBadge[tab]) {
              <a class="badge-noti" data-cy="tab-badge"></a>
            }
            <p>{{ tabValue(tab) }}</p>
          </li>
        }
      }
    </ul>
  </div>
} @else {
  <div class="space-tab-mobile">
    <ul class="scroll-menu">
      @for (tab of tabKeys; track tab) {
        <li data-cy="tab" [id]="getTabHtmlId(tab)" [class.is-current]="isActiveTab(tab)" (click)="onChangeTab(tab)">
          @if (isActiveTab(tab)) {
            <p>{{ tabValue(tab) }}</p>
          }
          @if (!isActiveTab(tab)) {
            <a class="tab-change-trigger">{{ tabValue(tab) }}</a>
          }
        </li>
      }
    </ul>
  </div>
}
